module.exports = __webpack_public_path__ + "static/dots-78629bf1bc454dfdba5b9fbfeb6024ba.svg";